import React from "react";
import { FormFeedback } from "reactstrap";
import Select from "react-select";

class DropDownMenu extends React.Component {
	handleChange = (data) => {
		if (
			this.props.name === "businessType" ||
			this.props.name === "customerType"
		) {
			this.props.onChange(this.props.name, [data.value]);
		} else {
			this.props.onChange(this.props.name, data.value);
		}
	};

	handleBlur = () => {
		this.props.onBlur(this.props.name, true);
	};

	render() {
		return (
			<>
				<Select
					options={this.props.options}
					onChange={this.handleChange}
					onBlur={this.handleBlur}
					value={this.props.value ? this.props.value.value : ""}
				/>
				{this.props.error !== "" && this.props.touched === true && (
					<div className="invalid-feedback" style={{ display: "block" }}>
						{this.props.error}
					</div>
				)}
			</>
		);
	}
}

export default DropDownMenu;
